import { useCallback } from 'react';

import { navigateToTeamsApp as navigateToTeamsAppBase } from '@atlaskit/teams-app-config/utils/teams-app-navigation/navigate-to-teams-app';
import type {
	NavigationActionPayloadVariants,
	NavigationResult,
} from '@atlaskit/teams-app-config/types';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useGetNavigateToTeamsApp = (): ((
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
) => NavigationResult) => {
	const { cloudId, orgId } = useSessionData();

	const getNavigateToTeamsApp = (
		navActionPayload: NavigationActionPayloadVariants,
		shouldOpenInSameTab?: boolean,
	): NavigationResult => {
		return navigateToTeamsAppBase({
			hostProduct: 'confluence',
			orgId,
			cloudId,
			userHasNav4Enabled: true,
			shouldOpenInSameTab,
			...navActionPayload,
		});
	};

	return useCallback(getNavigateToTeamsApp, [cloudId, orgId]);
};
